/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://mgjicqt3ijgkhb2upfvf3pjx5q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-nzcvjw55czbqrkltzxhmw537pm",
    "aws_cognito_identity_pool_id": "us-east-1:dfd824b0-d88a-4a4d-8919-f60c5b301915",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_QhAgvglrH",
    "aws_user_pools_web_client_id": "6ga5pcraidarogedd1e664ra9u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "source-data-docs-bf-picoprod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "map1a7a4144-picoprod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "map1a7a4144-picoprod"
            }
        }
    }
};


export default awsmobile;
